import { useNavigate } from "react-router-dom";
import img1 from "images/winetours.png";
import img2 from "images/winetour2.png";
import img3 from "images/weddingpic.png";
import img4 from "images/bechlourpic.png";
import img5 from "images/concertpic.png";
import img6 from "images/ladiespic.png";
import ButtonPrimary from "shared/Button/ButtonPrimary";

export default function EventsCovered() {
  const services = [
    {
      id: 3,
      title: "Luxury Wedding Shuttle Service",
      description:
        "Ensure a seamless and stylish ride on your special day with our Sprinter Van shuttle service. Whether transporting the bridal party, family, or guests, we provide a luxurious, comfortable, and stress-free experience. With elegant interiors, premium amenities, and reliable service, we'll get everyone to the venue on time—so you can focus on celebrating love and making memories.",
      image: img3,
    },
    {
      id: 4,
      title: "Epic Bachelor & Bachelorette Party Rides",
      description:
        "Kick off your bachelor or bachelorette party with a ride as exciting as the night ahead! Our party Sprinter Van shuttle service keeps the celebration going with premium sound, vibrant lighting, and spacious seating for your entire crew. Whether bar-hopping, heading to a club, or enjoying a weekend getaway, we provide safe, stylish, and reliable transportation—so you can party without the worry.",
      image: img4,
    },
    {
      id: 5,
      title: "Concert Shuttle: Arrive Like a VIP",
      description:
        "Turn up the excitement before you even reach the venue with our party Sprinter Van shuttle service! Avoid the hassle of parking and traffic while enjoying premium sound, vibrant lighting, and a party-ready atmosphere on the way to your favorite concert. Whether it's a small group or a full squad, we'll get you there safely, comfortably, and in style—because the night starts the moment you step inside.",
      image: img5,
    },
    {
      id: 6,
      title: "Ladies’ & Guys’ Night Out",
      description:
        "Take your night out to the next level with our party Sprinter Van shuttle service! Whether it’s a wild girls’ night or an unforgettable guys’ night, we’ve got the perfect ride to keep the party going. With premium sound, vibrant lighting, and spacious seating, you can enjoy the night worry-free while we handle the driving. No parking, no stress—just good vibes and great memories from start to finish!",
      image: img6,
    },
  ];

  const navigate = useNavigate();
  return (
    <>
      <h2 className="font-bold text-3xl my-4">Events We Cover</h2>
      <div className="py-2 px-4 bg-[#B4B4B433] rounded-2xl">
        <div className="grid grid-cols-1 lg:grid-cols-2 m-2 gap-12">
          <div className="">
            <p className="font-semibold text-xl ">1. Wine Tours</p>
            <p className="text-[#576071] text-md">
              Plan your next unforgettable wine-tasting experience with our
              exclusive VIP Wine Tour. Savor the finest selections, explore
              stunning vineyards, and enjoy a fun, luxurious, curated journey
              designed for wine enthusiasts. Sit back, relax, and let us handle
              the transportation—we’ll pick you up from anywhere in our local
              area and bring you back safely at the end of the tour.
            </p>
          </div>
          <div>
            <img src={img1} alt="img" />
          </div>
        </div>
        <div>
          <p className="font-semibold text-xl ">
            i. The Savage Grill Luxury Wine Tour & Exquisite Dining Experience
          </p>
          <p>
            Embark on a breathtaking wine tour through Southern California’s
            finest wineries, indulging in premium tastings, stunning vineyard
            views, and unforgettable moments—all while traveling in luxury and
            style aboard our Sprinter Van.
            <br />
            <br /> Your journey begins and ends at Savage Chef Bar & Grill in
            Menifee, CA, an upscale dining destination known for its
            fusion-inspired American cuisine crafted with the freshest
            ingredients. Savor their mouthwatering burgers, flavorful entrees,
            and handcrafted cocktails that elevate your dining experience to new
            heights.
            <br />
            <br /> After a day of exquisite wine tasting, enjoy an exclusive
            Chef's experience, where bold flavors and expert craftsmanship and
            presentation come together for the perfect finale to your tour.
            <br />
            <br /> ✨ Limited availability! Reserve your spot today and indulge
            in the ultimate wine and dining experience. ✨
          </p>
          <ButtonPrimary
            className="mt-4"
            onClick={() => {
              window.open("https://form.jotform.com/250818332688162");
            }}
          >
            Book Now
          </ButtonPrimary>
          <div className="border-b-2 mt-6 text-black mx-4" />
        </div>
        <div className="mt-2">
          <p className="font-semibold text-xl ">
            ii. Unwind & Indulge: Par 3 The Ultimate Wine Tour & Dining
            Experience
          </p>
          <p>
            Escape into a day of luxury, fine wine, and unforgettable moments as
            we take you on an exclusive wine tour through Southern California’s
            most scenic vineyards. Enjoy hand-selected wineries, premium
            tastings, and a stress-free journey in our luxury Sprinter Van,
            ensuring you can fully relax and savor every sip.
            <br />
            <br /> Your experience begins and ends at Par 3 Sports Bar & Grill,
            nestled in the heart of Corona, CA. This inviting eatery welcomes
            guests with a warm ambiance, friendly service, and a menu packed
            with mouthwatering dishes. Whether you’re in the mood for a
            leisurely dinner with loved ones or a laid-back meal at the bar, Par
            3 offers the perfect setting to unwind, laugh, and indulge after a
            day of wine tasting.
            <br />
            <br /> Let the flavors of the region and the comfort of great food,
            great company, and great wine create an experience you won’t forget.
            <br />
            <br />✨ Limited spots available—reserve your wine tour today and
            treat yourself to the perfect blend of adventure and indulgence!
          </p>
          <ButtonPrimary
            className="mt-4"
            onClick={() => {
              window.open("https://form.jotform.com/250800062858152");
            }}
          >
            Book Now
          </ButtonPrimary>
          <div className="border-b-2 mt-6 text-black mx-4" />
        </div>
        <div className="mt-2">
          <p className="font-semibold text-xl ">
            iii. The Wine Ranch's Exclusive Wine Tour & Gourmet Dining
          </p>
          <p>
            Embark on a luxurious wine tour through Southern California’s most
            breathtaking vineyards, where you’ll enjoy premium tastings,
            stunning views, and an unforgettable day of relaxation. Travel in
            style aboard our luxury Sprinter Van, ensuring a seamless,
            stress-free experience from start to finish.
            <br />
            <br /> Your journey begins and ends at Wine Ranch, a hidden gem
            nestled in Old Town Murrieta. This intimate yet elegant destination
            offers the charm of a boutique winery paired with a warm, inviting
            ambiance. Indulge in one-of-a-kind wines crafted in-house and savor
            a chef-curated menu featuring exclusive dishes you won’t find
            anywhere else. Whether you’re a wine enthusiast or simply looking
            for a unique escape, Wine Ranch sets the stage for a truly
            extraordinary experience.
            <br />
            <br /> ✨ Limited spots available—reserve your wine tour today and
            treat yourself to a day of fine wine, gourmet dining, and
            unforgettable moments! ✨
          </p>
          <ButtonPrimary
            className="mt-4"
            onClick={() => {
              window.open("https://form.jotform.com/250817990044157");
            }}
          >
            Book Now
          </ButtonPrimary>
          <div className="border-b-2 mt-6 text-black mx-4" />
        </div>
      </div>
      <div className="py-2 px-4 bg-[#B4B4B433] rounded-2xl mt-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 m-2 gap-12">
          <div className="">
            <p className="font-semibold text-xl ">
              2. Arrive in Style for Your Quinceañera
            </p>
            <p className="text-[#576071] text-md">
              Make your Quinceañera unforgettable with our luxury Sprinter Van
              shuttle service! Celebrate in style as we transport you and your
              guests in comfort, elegance, and fun. With spacious seating,
              premium sound, and vibrant lighting, the party starts the moment
              you step inside. Let us handle the ride so you can focus on making
              memories on your special day!
            </p>
          </div>
          <div>
            <img src={img2} alt="img" />
          </div>
        </div>
      </div>
      <div className="grid md:grid-cols-2 gap-6 mt-8">
        {services.map((service) => (
          <div
            key={service.id}
            className="bg-[#B4B4B433] rounded-2xl shadow-lg p-6 flex flex-col justify-between"
          >
            <h3 className="text-xl font-bold mb-3">
              {service.id}. {service.title}
            </h3>
            <p className="text-gray-700 mb-4">{service.description}</p>
            <img
              src={service.image}
              alt={service.title}
              className="w-full h-40 object-cover rounded-lg mb-4"
            />
            <ButtonPrimary
              className="max-w-fit"
              onClick={() => {
                window.open(
                  "https://form.jotform.com/250818332688162",
                  "_blank"
                );
              }}
            >
              Book Now
            </ButtonPrimary>
          </div>
        ))}
      </div>
    </>
  );
}
